"use strict";

exports.__esModule = true;

var _createReactContext = require("create-react-context");

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouterContext = (0, _createReactContext2.default)({});

exports.default = RouterContext;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/RouterContext.js
 ** module id = 100
 ** module chunks = 0
 **/